import { useState } from 'react'

import { Box, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

interface FilterGeomarketProps {
  selectedGeomarkets: string[]
  onChangeGeomarkets: (geomarkets: string[]) => void
  enabled: boolean
}

export default function FilterGeomarket({ selectedGeomarkets, onChangeGeomarkets, enabled }: FilterGeomarketProps) {
  const [inputValue, setInputValue] = useState('')
  const [showWarning, setShowWarning] = useState(false)
  const maxInputLength = 100

  const handleBlur = () => {
    const trimmedValue = inputValue.trim()
    if (trimmedValue && !selectedGeomarkets.includes(trimmedValue)) {
      onChangeGeomarkets([...selectedGeomarkets, trimmedValue])
      setInputValue('')
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={16}
    >
      <Typography
        component="div"
        variant="subtitle2"
      >
        Geomarket
      </Typography>
      <Autocomplete
        disabled={!enabled}
        value={selectedGeomarkets}
        multiple
        filterSelectedOptions
        freeSolo
        options={[]}
        getOptionLabel={(option) => `${option}`}
        onChange={(_, selectedGeomarkets) => onChangeGeomarkets(selectedGeomarkets as string[])}
        inputValue={inputValue}
        onBeforeInput={() => {
          if (inputValue.length === maxInputLength) {
            setShowWarning(true)
          }
        }}
        onInputChange={(_, value) => {
          setShowWarning(false)
          setInputValue(value)
        }}
        onBlur={handleBlur}
        ChipProps={{ color: 'primary', variant: 'outlined' }}
        renderInput={(params) => (
          <TextField
            {...params}
            color="primary"
            variant="outlined"
            label="Geomarket"
            helperText={
              showWarning
                ? `Geomarkets cannot be more than ${maxInputLength} characters long.`
                : 'Press Enter to add more geomarkets'
            }
            error={showWarning}
            inputProps={{
              ...params.inputProps,
              maxLength: maxInputLength,
            }}
          />
        )}
      />
    </Box>
  )
}
